import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common/Page";
import { api, errMsg } from "@/lib/api";

export const NOTE_FIELDS = [
  ["content", "Conteúdo estudado"],
  ["observations", "Observações"],
  ["difficulties", "Dificuldades encontradas"],
  ["positives", "Pontos positivos"],
  ["homework", "Tarefa de casa"],
  ["next_content", "Conteúdo para próxima aula"],
];

export const NotesDialog = ({ lesson, open, onOpenChange, onSaved }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (open) setForm(Object.fromEntries(NOTE_FIELDS.map(([k]) => [k, lesson?.note?.[k] || ""])));
  }, [open, lesson]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/classes/${lesson.id}/notes`, Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v || null])));
      toast.success("Anotações salvas");
      onSaved?.();
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="notes-dialog">
        <DialogHeader><DialogTitle>Anotações da aula</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {NOTE_FIELDS.map(([k, label]) => (
            <Field key={k} label={label}>
              <Textarea rows={3} value={form[k] || ""} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} data-testid={`note-${k}-input`} />
            </Field>
          ))}
          <DialogFooter className="sm:col-span-2"><Button type="submit" data-testid="notes-submit-btn">Salvar anotações</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
